// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const vespiquen: PokeData = {
  "id": 416,
  "name": "vespiquen",
  "height": 12,
  "weight": 385,
  "base_experience": 166,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "poison-sting",
    "pin-missile",
    "toxic",
    "recover",
    "confuse-ray",
    "fury-swipes",
    "slash",
    "destiny-bond",
    "swagger",
    "fury-cutter",
    "pursuit",
    "sweet-scent",
    "aromatherapy",
    "silver-wind",
    "roost",
    "air-slash",
    "bug-buzz",
    "power-gem",
    "captivate",
    "bug-bite",
    "attack-order",
    "defend-order",
    "heal-order",
    "struggle-bug",
    "fell-stinger",
    "aromatic-mist"
  ],
  "moves": [
    "gust",
    "pin-missile",
    "confuse-ray",
    "pursuit",
    "aromatherapy",
    "roost",
    "air-slash",
    "bug-buzz",
    "bug-bite",
    "heal-order",
    "peck",
    "infest",
    "hurricane"
  ],
  "evolution_chain": {
    "id": 214,
    "item": null,
    "species": [
      {
        "name": "combee",
        "order": 443,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "vespiquen",
        "order": 444,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 415,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 21,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": {
              "name": "female"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 167,
    "speed": 78,
    "ability_power": 155
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
